
















































import Vue from 'vue'

import { client } from '@/services/ApiClient'

export default Vue.extend({
  name: 'Upload',

  beforeRouteEnter(to, from, next) {
    // User must be logged in. Otherwise redirect to login.
    next(vm => {
      const { isLoggedIn, user } = vm.$root.$data
      const canSee = isLoggedIn && user.isAdmin
      if (!canSee) {
        vm.$router.replace({ name: 'Login' })
      }
    })
  },

  data: () => ({
    isUploading: false as boolean,
    hasError: false as boolean,
    isValid: true as boolean,
    file: null as File | null,

    pagesToProcess: -1 as number,
    pagesProcessed: 0 as number,
    showProgressBar: false as boolean,
    progressIndeterminate: true as boolean,

    statusToken: '' as string,

    timeoutCtx: null as number | undefined | null,
  }),

  computed: {
    progress(): number {
      return this.pagesToProcess > 0 ? (this.pagesProcessed / this.pagesToProcess) * 100 : 0
    },
  },

  beforeDestroy() {
    if (this.timeoutCtx) {
      clearTimeout(this.timeoutCtx)
    }
  },

  methods: {
    async upload() {
      this.validate()
      if (!this.isValid || !this.file) return
      this.isUploading = true

      // prepare progress bar
      this.pagesToProcess = -1
      this.pagesProcessed = 0
      this.showProgressBar = true

      try {
        const { numberOfPages, statusToken } = await client.uploadFile(this.file)
        this.statusToken = statusToken
        this.pagesToProcess = numberOfPages
        this.progressIndeterminate = false
        this.timeoutCtx = setTimeout(() => this.pollStatus(), 1000)
      } catch (e) {
        console.error('error uploading file', e)
        this.hasError = true
        this.isUploading = false
        this.showProgressBar = false
      }
    },
    async pollStatus(): Promise<void> {
      try {
        const { parsedPages } = await client.pollStatus(this.statusToken)
        this.pagesProcessed = parsedPages
      } catch (e) {
        console.error('Error when polling status: ', e)
      }

      if (this.pagesProcessed === this.pagesToProcess) {
        this.isUploading = false
        this.showProgressBar = false
        this.reset()
      } else {
        this.timeoutCtx = setTimeout(() => this.pollStatus(), 1000)
      }
    },
    validate(): void {
      ;(this.$refs.form as HTMLFormElement).validate()
    },
    reset(): void {
      ;(this.$refs.form as HTMLFormElement).reset()
      this.file = null
      this.isValid = true
    },
  },
})
